<template>
  <main role="Review">
    <div class="card">
      <div class="card-body">
        <div class="card-header">
          <h4 class="card-title">Ulasan</h4>
        </div>

        <div class="card-header">
          <h5 class="">Ulasan Mall</h5>
        </div>

        <div class="row p-3">
          <div class="card-on-card">
            <div class="card-header"></div>
            <div class="table-responsive">
              <table
                id="getReviewMall"
                class="
                  table table-condensed
                  text-center
                  table-hover table-loader
                "
                width="100%"
              >
                <thead>
                  <tr class="table-condensed text-sm-center">
                    <th scope="col">No</th>
                    <th scope="col">Firstname</th>
                    <th scope="col">Jabatan</th>
                    <th scope="col">Nama Sekolah</th>
                    <th>Rate</th>
                    <th>Ulasan</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="reviewMallData.length === 0">
                    <td class="table-secondary" colspan="6">Tidak ada data</td>
                  </tr>
                  <tr v-for="(rd, index) in reviewMallData" :key="index">
                    <th scope="row">{{ index + 1 }}</th>
                    <td>{{ rd.firstname }}</td>
                    <td>{{ rd.jabatan }}</td>
                    <td>{{ rd.nama_sekolah }}</td>
                    <td>
                      <span
                        v-for="(star, index) in Number(rd.rate)"
                        :key="index"
                      >
                        <span class="fas text-warning fa-star checked"></span>
                      </span>
                    </td>
                    <td>{{ rd.ulasan }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="card-header">
          <h5 class="">Ulasan Product</h5>
        </div>

        <div class="row p-3">
          <div class="card">
            <div class="table-responsive">
              <table
                id="getReviewProductMall"
                class="
                  table table-condensed
                  text-center
                  table-hover table-loader
                "
                width="100%"
              >
                <thead>
                  <tr class="table-condensed text-sm-center">
                    <th scope="col">No</th>
                    <th scope="col">Firstname</th>
                    <th scope="col">Jabatan</th>
                    <th scope="col">Nama Sekolah</th>
                    <th scope="col">Nama Produk</th>
                    <th scope="col">Rate</th>
                    <th scope="col">Ulasan</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="reviewProductData.length === 0">
                    <td class="table-secondary" colspan="7">Tidak ada data</td>
                  </tr>
                  <tr v-for="(rpd, index) in reviewProductData" :key="index">
                    <th scope="row">{{ index + 1 }}</th>
                    <td>{{ rpd.firstname }}</td>
                    <td>{{ rpd.jabatan }}</td>
                    <td>{{ rpd.nama_sekolah }}</td>
                    <td
                      width="30%"
                      class="text-wrap"
                      @click="goToProduct(rpd.product_id)"
                    >
                      <u style="cursor: pointer">{{ rpd.name }}</u>
                    </td>
                    <td>
                      <span
                        v-for="(star, index) in Number(rpd.rate)"
                        :key="index"
                      >
                        <span class="fas text-warning fa-star checked"></span>
                      </span>
                    </td>
                    <td>{{ rpd.ulasan }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { mapGetters } from "vuex";
// import axios from 'axios'
import $ from "jquery";
export default {
  data() {
    return {
      reviewMallData: "",
      reviewProductData: "",
    };
  },
  mounted() {
    this.getReviewMall();
    this.getReviewProductMall();
  },
  computed: {
    ...mapGetters({
      isLoggedIn: "isLoggedIn",
      user: "user",
      notif: "notif",
    }),
  },
  methods: {
    goToProduct(productId) {
      this.$router.push(`product/detail/${productId}`);
    },
    getReviewMall() {
      fetch(
        `https://siplah.eurekabookhouse.co.id/staging/backendseller/katalog/review_api/ulasan_mall?m_id=${this.user.id}`
      )
        .then((response) => response.json())
        .then((res) => {
          this.reviewMallData = res;
          $("#getReviewMall").removeClass("table-loader");
          // console.log(res);
        });
    },
    getReviewProductMall() {
      fetch(
        `https://siplah.eurekabookhouse.co.id/stagingging/backendseller/katalog/review_api/ulasan_product_mall?m_id=${this.user.id}`
      )
        .then((response) => response.json())
        .then((res) => {
          this.reviewProductData = res;
          $("#getReviewProductMall").removeClass("table-loader");
          // console.log(res);
        });
    },
  },
};
</script>
